import { render, staticRenderFns } from "./CopiarCadastrosFiscais.vue?vue&type=template&id=251a3d76"
import script from "./CopiarCadastrosFiscais.vue?vue&type=script&lang=js"
export * from "./CopiarCadastrosFiscais.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports